// Directive purely used to include footer for the sg-expansion

(() => {
  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgExpansionFooter', sgExpansionFooter);

  function sgExpansionFooter () {
    return {
      templateUrl: 'app-legacy/components/sg-expansion-panel/sg-expansion-panel-footer.html',
      scope: {
        save: '&',
        cancel: '&'
      },
      controller: 'sgExpansionFooterController',
      controllerAs: 'expPnlFooterCtrl'
    };
  }
})();
